import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Row of icon-only actions (edit, delete) with adequate touch targets on mobile.
 */
export function IconActionBar({ className, children, ...rest }) {
  return (
    <div
      className={cn(
        'flex shrink-0 flex-wrap items-center justify-end gap-2',
        '[&_button]:inline-flex [&_button]:min-h-[44px] [&_button]:min-w-[44px] [&_button]:touch-manipulation [&_button]:items-center [&_button]:justify-center',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
